export const ARTICLE_CONTENT_ID = 'article-content'
